<template>
    <div
        class="flex flex-col items-center justify-center flex-grow w-full mx-10"
    >
        <component
            ref="Furniture"
            v-for="(Furniture, index) in FurnitureCardArray"
            :key="Furniture.key"
            :is="Furniture.model"
            :data="Furniture.object"
            v-on:remove="removeFurniture($event, index)"
        />
        <base-add-button
            title="Ajouter Mobilier et bureaux"
            @click="pushArray"
        />
        <div class="grid items-center justify-center w-full grid-cols-10 ">
            <base-primary-button
                title="Suivant"
                @click="nextStep"
                class="w-full col-span-6 col-start-3"
            />
            <div
                @click="skipStep"
                class="flex items-center justify-center col-span-2 col-start-9 p-3 mb-6 space-x-2 text-gray-500 cursor-pointer hover:underline hover:text-gray-800 "
            >
                <span>Ignorer cette étape</span>
                <svg
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 5l7 7-7 7M5 5l7 7-7 7"
                    ></path>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import FurnitureCard from "./components/furnitureCard";
import { mapState } from "vuex";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    components: {
        FurnitureCard
    },
    data() {
        return {
            FurnitureCardArray: []
        };
    },
    mixins: [scrollToError],

    mounted() {
        this.FurnitureCardArray = this.$store.getters[
            "EtudeTechnique/getFurnitureCard"
        ];
        this.$store.dispatch("forms/currentStep", "Mobilier et bureaux");
    },

    methods: {
        pushArray() {
            if (!this.checkForms()) {
                this.FurnitureCardArray.push({
                    model: "furniture-card",
                    key: new Date().getTime(),
                    object: {
                        id: new Date().getTime(),
                        image: null,
                        designation: "",
                        nombre: 1,
                        caracteristique: "",
                        etat: "",
                        prix: null,
                        nomFournisseur: "",
                        origine: ""
                    }
                });

                this.$refs.Furniture[
                    this.$refs.Furniture.length - 1
                ].scrollToRef();
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        nextStep() {
            if (!this.checkForms() && this.furnitureLength >= 1) {
                this.$store.dispatch("EtudeTechnique/SaveFurniture");
                this.$router.push({
                    name: "materiel_informatique",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        skipStep() {
            this.$router.push({
                name: "materiel_informatique",
                params: { uid: `${this.$store.state.user.bpiId}` }
            });
        },
        checkForms() {
            let formsHasError = false;
            this.$refs.Furniture.forEach(item => {
                if (!item.addFurnitureCard()) {
                    formsHasError = true;
                }
            });
            return formsHasError;
        },
        removeFurniture(payload, index) {
            this.$store.dispatch("EtudeTechnique/removeFurniture", payload);
            this.FurnitureCardArray.splice(index, 1);
        }
    },
    computed: {
        ...mapState("EtudeTechnique", {
            furnitureLength: state => state.furnitureCard.length
        })
    }
};
</script>

<style></style>
